import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import { useGraph } from "../../blocks/GraphProvider/GraphProvider";
import { instanceIdentifier } from "../../blocks/GraphData/internal/graphLookup";
import Chip from "../Chip/Chip";
import Tooltip from "../Tooltip/Tooltip";
import styles from "./InstanceIndex.module.scss";

export interface InstanceIndexProps {
  path?: string;
  className?: string;
}

const DefaultInstanceIndex = (props: InstanceIndexProps) => {
  const { path, className } = props;
  const actualIndex = path?.split("/").pop();

  const graphContext = useGraph();
  const graph = graphContext?.graph;

  let identifier = actualIndex;
  let hasIdentifier = false;

  if (path && graph) {
    const fetchedIdentifier = instanceIdentifier(graph, path) as string | null | undefined;
    if (fetchedIdentifier && fetchedIdentifier !== actualIndex) {
      identifier = fetchedIdentifier;
      hasIdentifier = true;
    }
  }

  if (identifier === undefined || identifier === null) return null;

  const chip = (
    <Chip
      className={clsx(styles.instanceIndex, className)}
      backgroundColor="rgb(229, 231, 235)"
      data-deci-instance-index="true"
    >
      {identifier}
    </Chip>
  );

  // If we have an identifier that differs from the actual index, show a tooltip
  if (hasIdentifier && actualIndex) {
    return (
      <Tooltip>
        <Tooltip.Trigger asChild={true}>
          {chip}
        </Tooltip.Trigger>
        <Tooltip.Content>
          Index: {actualIndex}
        </Tooltip.Content>
      </Tooltip>
    );
  }

  return chip;
};

const InstanceIndex = createPluggable<InstanceIndexProps>("deci.instanceIndex", DefaultInstanceIndex);

export default InstanceIndex;
